// src/utils/auth.js
import { logout as logoutApi } from "../api/authApi";
import { resetOrbieeChatSocket } from "../services/websocket";

// // --- Auth Token ---
// export const getAuthToken = () => {
//   return document.cookie.replace(
//     /(?:(?:^|.*;\s*)authToken\s*=\s*([^;]*).*$)|^.*$/,
//     "$1"
//   );
// };

// // --- Username ---
// export const getUsername = () => {
//   const match = document.cookie.match(new RegExp("(^| )username=([^;]+)"));
//   return match ? decodeURIComponent(match[2]) : null;
// };

// // --- Full User Profile ---
// const USER_PROFILE_COOKIE = "userProfile";

// export const getUserProfile = () => {
//   const match = document.cookie.match(new RegExp(`(^| )${USER_PROFILE_COOKIE}=([^;]+)`));
//   if (!match) return null;
//   try {
//     return JSON.parse(decodeURIComponent(match[2]));
//   } catch (e) {
//     console.warn("Failed to parse user profile cookie", e);
//     return null;
//   }
// };

// // --- Auth State ---
// export const isAuthenticated = () => {
//   return !!getAuthToken() && !!getUsername();
// };

// // --- Clear All Auth Data ---
// export const signOut = () => {
//   const expire = "path=/; max-age=0; SameSite=Strict; Secure";
//   document.cookie = `authToken=; ${expire}`;
//   document.cookie = `username=; ${expire}`;
//   document.cookie = `${USER_PROFILE_COOKIE}=; ${expire}`;
// };


// --- Auth Token ---
export const getAuthToken = () => {
  return document.cookie.replace(
    /(?:(?:^|.*;\s*)authToken\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  );
};

// --- Username ---
export const getUsername = () => {
  const match = document.cookie.match(new RegExp("(^| )username=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

// --- User Role ---
export const getUserRole = () => {
  const match = document.cookie.match(/(?:^|;\s*)userRole\s*=\s*([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
};

// --- Check if Admin ---
export const isAdmin = () => {
  
  return getUserRole() === "A";
};
export const checkUser = () => {
  if(getUserRole() === "C"||getUserRole() === null){
    return false
  }
  if(getUserRole() === "A"){
    return true;
  }

};

// --- Full User Profile ---
const USER_PROFILE_COOKIE = "userProfile";

/**
 * Use backend customer_name when present; otherwise derive from email local-part.
 * e.g. emily.parker@gmail.com → "Emily parker"
 */
export function deriveCustomerNameFromEmail(email, existingName = "") {
  const trimmed = String(existingName ?? "").trim();
  if (trimmed) return trimmed;

  const emailStr = String(email ?? "").trim();
  const at = emailStr.indexOf("@");
  if (at <= 0) return "";

  const local = emailStr.slice(0, at);
  const parts = local.split(/[._-]+/).filter(Boolean);
  if (!parts.length) return "";

  return parts
    .map((part, index) => {
      const lower = part.toLowerCase();
      if (!lower) return "";
      if (index === 0) {
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      }
      return lower;
    })
    .filter(Boolean)
    .join(" ");
}

export const getUserProfile = () => {
  const match = document.cookie.match(new RegExp(`(^| )${USER_PROFILE_COOKIE}=([^;]+)`));
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match[2]));
  } catch (e) {
    console.warn("Failed to parse user profile cookie", e);
    return null;
  }
};

// --- Auth State ---
export const isAuthenticated = () => {
 
 
  return !!getAuthToken() && !!getUsername();
};

// --- Clear All Auth Data ---
// export const signOut = () => {
//   const expire = "path=/; max-age=0; SameSite=Strict; Secure";
//   document.cookie = `authToken=; ${expire}`;
//   document.cookie = `username=; ${expire}`;
//   document.cookie = `userRole=; ${expire}`;
//   document.cookie = `${USER_PROFILE_COOKIE}=; ${expire}`;
// };

// src/utils/auth.js
export const signOut = async (showSuccessMessage = true, onClosePopup = null) => {
  try {
    resetOrbieeChatSocket();
    // 1. Call logout API first
    const logoutResult = await logoutApi();
    
    // 2. Clear all session storage
    try {
      sessionStorage.clear();
    } catch (e) {
      console.warn("Failed to clear session storage", e);
    }

    // 3. Clear all local storage
    try {
      localStorage.clear();
    } catch (e) {
      console.warn("Failed to clear local storage", e);
    }

    // 4. Clear cookies
    const isSecure = window.location.protocol === "https:";
    const clearFlags = `path=/; max-age=0; SameSite=Strict${isSecure ? "; Secure" : ""}`;

    ["authToken", "username", "userRole", "userProfile"].forEach(name => {
      document.cookie = `${name}=; ${clearFlags}`;
    });

    // 5. Show success message
    if (showSuccessMessage) {
      alert(logoutResult.message || "Logged out successfully");
    }

    // 6. Close popup/modal if callback provided
    if (onClosePopup && typeof onClosePopup === "function") {
      onClosePopup();
    }

    // 7. Close any open auth modals
    window.dispatchEvent(new CustomEvent("closeAuthModal"));

    // 8. Redirect to landing page instead of reload
    window.location.href = "/";
  } catch (error) {
    console.error("Sign out error:", error);
    // Still proceed with local logout even if API fails
    resetOrbieeChatSocket();

    // Clear all session storage
    try {
      sessionStorage.clear();
    } catch (e) {
      console.warn("Failed to clear session storage", e);
    }

    // Clear all local storage
    try {
      localStorage.clear();
    } catch (e) {
      console.warn("Failed to clear local storage", e);
    }

    // Clear cookies
    const isSecure = window.location.protocol === "https:";
    const clearFlags = `path=/; max-age=0; SameSite=Strict${isSecure ? "; Secure" : ""}`;
    ["authToken", "username", "userRole", "userProfile"].forEach(name => {
      document.cookie = `${name}=; ${clearFlags}`;
    });
    
    if (showSuccessMessage) {
      alert("Logged out successfully");
    }
    
    if (onClosePopup && typeof onClosePopup === "function") {
      onClosePopup();
    }
    
    // Redirect to landing page instead of reload
    window.location.href = "/";
  }
};